import App from "../../app";
import Vue from "vue";
import VueWait from 'vue-wait'
import { HalfCircleSpinner } from 'epic-spinners'
import {clearSession} from "../../services/SessionService";
import LoginPage from "./pages/LoginPage.vue";
import ForgotPasswordPage from "./pages/ForgotPasswordPage.vue";

Vue.component('half-circle-spinner', HalfCircleSpinner);
Vue.component('password-rules-validator', require('../../theme/atoms/PasswordRulesValidator.vue').default);
Vue.component('login-page', LoginPage);
Vue.component('forgot-password-page', ForgotPasswordPage);

new Vue({
    el: '#app',
    extends: App,
    wait: new VueWait(),
    data() {
        return {
            model: {
                new_password: null,
                new_password_confirmation: null,
            },
            validationStatus: false,
            initTimezone: false,
        }
    },
    computed: {
        passwordsMatch: function () {
            return Boolean(
                this.model.new_password &&
                this.model.new_password_confirmation &&
                this.model.new_password === this.model.new_password_confirmation
            );
        }
    },
    mounted() {
        clearSession();
    },
})
